module.exports = __webpack_public_path__ + "img/banner3.34eaabfd.png";